// extracted by mini-css-extract-plugin
export default {"cover":"redshift_cover__fF7sC","textContainer":"redshift_textContainer__OTdCv"};